import { useId } from "react";

/** Label and input share one field surface, as in the design. */
export function AssetNameField({
  label,
  value,
  onChange,
  onSubmit,
}: {
  /** Doubles as the accessible name of the input, e.g. "Asset Name". */
  label: string;
  value: string;
  onChange: (name: string) => void;
  /** Fired on Enter, so the host modal's primary action is reachable from
   *  the field. */
  onSubmit: () => void;
}) {
  const inputId = useId();

  return (
    <div className="flex min-w-0 flex-1 items-center gap-2 rounded-lg border border-[var(--stroke-field)] bg-[var(--bg-field)] p-3">
      <label
        htmlFor={inputId}
        className="shrink-0 text-sm font-semibold text-[var(--text-primary)]"
      >
        {label}
      </label>
      <input
        id={inputId}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onSubmit();
          }
        }}
        placeholder="Name this asset"
        className="min-w-0 flex-1 bg-transparent text-sm text-white outline-none placeholder-[var(--text-secondary)]"
      />
    </div>
  );
}
